import { InViewport } from '@gik/core/components/InViewport';
import type WordpressPost from '@gik/core/models/wordpress/WordpressPost';
import { ErrorPageSection } from '@gik/core/pages/Error/ErrorPageSection';
import type { UIComponent } from '@gik/core/types/UI';
import bemBlock from '@gik/core/utils/bemBlock';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { CreateClickedLocation } from '@gik/create/enums/CreateAnalyticsEnums';
import { InkindUsesSection } from '@gik/marketing/components/InkindUses';
import WhySupportMattersSection from '@gik/marketing/components/WhySupportMatters';
import { PageHeader } from '@gik/ui/gik/PageHeader';
import { PageSection } from '@gik/ui/gik/PageSection';
import { StartInkindContent } from '@gik/ui/gik/StartInkindCard';
import { TestimonialsCarouselSection } from '@gik/ui/gik/TestimonialsCarouselSection';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BenefitsHero } from '../../components/BenefitsHero';
import { BenefitsListSection } from '../../components/BenefitsList';
import { MarketingNavSection } from '../../components/MarketingNav/MarketingNavSection';
import { translationKeys } from './i18n/en';

export type BenefitsPageServerProps = {
  posts: WordpressPost[];
};

export type BenefitsPageProps = {} & UIComponent;

function BenefitsPageComp() {
  const bem = bemBlock('benefits-page');
  const { t } = useTranslation();

  return (
    <div className={bem()}>
      <PageHeader variant="purps" decoration="foliage">
        <h1>{t(translationKeys.title)}</h1>
      </PageHeader>

      <PageSection className={bem('lead')} noPadBottom>
        <p className="gik-section-lead">{t(translationKeys.leadDescription)}</p>
      </PageSection>

      <InViewport height={630}>
        <PageSection noPadTop>
          <BenefitsHero />
        </PageSection>
      </InViewport>

      <InViewport height={241}>
        <BenefitsListSection />
      </InViewport>

      <InViewport height={586}>
        <InkindUsesSection />
      </InViewport>

      <InViewport height={572}>
        <WhySupportMattersSection />{' '}
      </InViewport>

      <InViewport height={394}>
        <TestimonialsCarouselSection />
      </InViewport>

      <InViewport height={131}>
        <PageSection noPadTop>
          <StartInkindContent trackingId={CreateClickedLocation.BENEFITS_PAGE} />
        </PageSection>
      </InViewport>

      <InViewport height={461}>
        <MarketingNavSection variant="purps" />
      </InViewport>
    </div>
  );
}

export const BenefitsPage = withComponentErrorBoundary(BenefitsPageComp, { ErrorFallback: ErrorPageSection });
